import { useState } from "react";
import { taskService } from "@miplatform/api";
import { HTTP_STATUSES, ORDER_STATUS } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IOrder } from "@miplatform/types";
import { sortOrdersByStatus } from "@miplatform/utils";

const getFilters = (key: string, value: string) => {
  return {
    [key]: { type: "guid", value },
  };
};

export const useHomeSearchOption = (option: { id: string }) => {
  const stateManager = useComponentState();
  const [orders, setOrders] = useState<IOrder[] | null>(null);

  const getOrders = async (id: string) => {
    stateManager.run(async () => {
      const response = await taskService.order.getAll({
        filters: getFilters("homeId", id),
      });
      if (response.status === HTTP_STATUSES.OK) {
        const sortedOrders = sortOrdersByStatus(response.data);
        setOrders(sortedOrders);
      }
    });
  };

  const currentOrder = orders && orders.length > 0 ? orders[0] : null;

  const startDate =
    orders && orders.length > 0
      ? orders.reduce((earliest, order) => {
          const orderDate = new Date(
            order?.approvedStartDate || order.receivedDate
          );
          return orderDate < earliest ? orderDate : earliest;
        }, new Date(orders[0].approvedStartDate || orders[0].receivedDate))
      : null;

  const completeDate =
    orders && orders.length > 0
      ? orders
          .filter(
            (order) =>
              order.orderStatus === ORDER_STATUS.COMPLETE || order.completeDate
          )
          .reduce((latest, order) => {
            const orderDate = order?.completeDate
              ? new Date(order.completeDate)
              : new Date();
            return orderDate > latest ? orderDate : latest;
          }, new Date(0))
      : null;

  return {
    orders,
    currentOrder,
    startDate,
    completeDate,
    isLoading: stateManager.isBusy(),
    getOrders,
  };
};
